import { render, staticRenderFns } from "./AdministrativeFile.vue?vue&type=template&id=044cabe2&"
import script from "./AdministrativeFile.vue?vue&type=script&lang=js&"
export * from "./AdministrativeFile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports